import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Destroyable } from '../../utils/mixins/destroyable.mixin';
import { WelcomePageComponent } from '../../common/welcome-page/welcome-page.component';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [WelcomePageComponent],
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.scss'
})
export class SignupComponent extends Destroyable(Object) {
  constructor(private authenticationService: AuthenticationService, private router: Router) {
    super();
  }

  onSignupClicked([email, password]: [string, string | null]): void {
    this.authenticationService
      .register(email, password!)
      .pipe(this.takeUntilDestroyed())
      .subscribe(() => this.router.navigate(['login']));
  }
}
